export const draftName = 'createShutdownDraft';
